export const get = path => ( object, defaultValue = null ) =>
	path.reduce( ( xs, x ) =>
	( xs && xs[ x ] ) ? xs[ x ] : defaultValue, object )

export const loop = ( items, callback, sortKeys = false ) => {
	if ( ! items || ! Object.keys( items ).length ) {
		return
	}

	if ( ! sortKeys ) {
		sortKeys = Object.keys( items )
	}

	return sortKeys.map( ( key, i ) => {
		return callback( key, items[ key ], i )
	} )
}
